import {
  Factory, CheckCircle2, AlertTriangle, Clock
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ScheduleSummaryCards = ({ scheduleData }) => {
  if (!scheduleData) return null;
  const cards = [
    { label: "Total Orders", value: scheduleData.total_orders, icon: Factory, color: "text-primary", testId: "total-orders" },
    { label: "On Time", value: scheduleData.on_time_orders, icon: CheckCircle2, color: "text-emerald-600", iconColor: "text-emerald-500", testId: "on-time-orders" },
    { label: "Late Orders", value: scheduleData.late_orders, icon: AlertTriangle, color: "text-red-600", iconColor: "text-red-500", testId: "late-orders" },
    { label: "Total Hours", value: `${scheduleData.total_production_hours}h`, icon: Clock, color: "text-primary", testId: "total-hours" },
  ];
  return (
    <div className="grid grid-cols-4 gap-4">
      {cards.map((c) => (
        <Card key={c.testId} className="card-industrial">
          <CardContent className="pt-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{c.label}</p>
                <p className={`text-2xl font-bold ${c.color}`} data-testid={c.testId}>{c.value}</p>
              </div>
              <c.icon className={`w-8 h-8 ${c.iconColor || c.color} opacity-50`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ScheduleSummaryCards;
